import {useEffect, useState} from "react";
import CheckoutForm from "./common/stripe/CheckoutForm";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import {lookupClientSecret} from "./common/api/CartApi";
import Meta from "./common/Meta";

export default function CheckoutPage(props) {

  const [clientSecret, setClientSecret] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    lookupClientSecret(props?.client).then((result) => {
      setClientSecret(result['clientSecret']);
      setStripePromise(loadStripe(result['publishableKey']));
    }).catch((err)=>{
      props.handleError(err.response.data);
    });
  }, []);

  return (
    <div>
      <Meta pageTitle={'Checkout'}/>
      {clientSecret &&
        <Elements
          options={{
            clientSecret: clientSecret
          }}
          stripe={stripePromise}>
          <CheckoutForm
            handleSuccess={props.handleSuccess}
            handleError={props.handleError}
            client={props?.client}
            clientSecret={clientSecret}/>
        </Elements>
      }
    </div>
  );
}